__turbopack_context__.v({
  "container": "partners-banner-module-scss-module__nIkjRW__container",
  "heading": "partners-banner-module-scss-module__nIkjRW__heading",
  "inner": "partners-banner-module-scss-module__nIkjRW__inner",
  "logo": "partners-banner-module-scss-module__nIkjRW__logo",
  "logo-item": "partners-banner-module-scss-module__nIkjRW__logo-item",
  "logos": "partners-banner-module-scss-module__nIkjRW__logos",
});
